import {
  Container,
  Typography,
  Box,
  Stack,
} from "@mui/material";
import React from 'react';
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
// import CoSportRankingCarousel from "../components/leaderBoard/CoSportRankingCarousel/index.jsx";
import CoSportAnalyticsCarousel from "../components/leaderBoard/CoSportAnalyticsCarousel/CoSportAnalyticsCarousel.jsx";
import { getStoredAccountOrgType } from "../helper/AccountHelper.js";
import { useEffect, useState } from "react";

import { AdminApi } from "../api/AdminApi.js";
import { getCurrentDateStr } from "../helper/StringHelper.js";
const TODAY = getCurrentDateStr(); // new Date().toISOString().split("T")[0];


export default function Page() {
  const navigate = useNavigate();
  useEffect(() => {
    // let timeslot = searchParams.get("timeslot") || 0;

    // AdminApi.loadEventLeaderboardCallback(eventId, TODAY, timeslot, (data) => {
    //   setLeaderData(data);
    // });
    // return;
    // // const result = await AdminApi.loadEvent(eventId, TODAY, timeslot);
  }, []);


  const handleOnBackClicked = () => {
    console.debug("handleOnBackClicked")
    navigate("/");
  };

  const orgType = getStoredAccountOrgType();
  // console.debug("orgType: ", orgType);
  // const theme = orgType; 
  // const theme = "primary";
  // forceUpdate(n => !n)

  return (
    <CoSportAnalyticsCarousel onBackClicked={handleOnBackClicked} orgType={orgType} />

  );
}
